import {
  SET_APPOINTMENT_ID,
  SET_USER_PREFERENCE,
  SET_SESSION_TYPE,
  SET_SESSION_STUDENT,
  SET_SESSION_DURATION,
  SET_SESSION_REMAINING_HOUR,
  SET_APPOINTMENT_FOR,
  SET_SESSION_DATE,
  SET_SESSION_START_TIME,
  SET_COMMENT,
  SET_NOTES,
  SET_PRACTICE_WORK_GIVEN,
  SET_NEXT_DATE,
  RESET_SESSION_DATA,
  SET_SHOW_REPORT_BUTTON,
  SET_PRACTICE_WORK_GIVEN_DETAIL,
  SET_SESSION_END_TIME
} from "./sessionTypes";

export const setsessionid = (id) => ({
  type: SET_APPOINTMENT_ID,
  payload: id,
});

export const setUserPreference = (preference) => ({
  type: SET_USER_PREFERENCE,
  payload: preference,
});

export const setSessionType = (type) => ({
  type: SET_SESSION_TYPE,
  payload: type,
});

export const setSessionStudent = (student) => ({
  type: SET_SESSION_STUDENT,
  payload: student,
});

export const setSessionDuration = (duration) => ({
  type: SET_SESSION_DURATION,
  payload: duration,
});

export const setSessionRemainingHour = (hours) => ({
  type: SET_SESSION_REMAINING_HOUR,
  payload: hours,
});

export const setAppointmentFor = (value) => ({
  type: SET_APPOINTMENT_FOR,
  payload: value,
});

export const setSessionDate = (date) => ({
  type: SET_SESSION_DATE,
  payload: date,
});

export const setSessionStartTime = (time) => ({
  type: SET_SESSION_START_TIME,
  payload: time,
});

export const resetSessionData = () => ({
  type: RESET_SESSION_DATA,
});


export const setComment = (comment) => ({
  type: SET_COMMENT,
  payload: comment,
});

export const setNotes = (notes) => ({
  type: SET_NOTES,
  payload: notes,
});

export const setPracticeWorkGiven = (practiceWork) => ({
  type: SET_PRACTICE_WORK_GIVEN,
  payload: practiceWork,
});

export const setNextDate = (nextDate) => ({
  type: SET_NEXT_DATE,
  payload: nextDate,
});

export const setShowReportButton = (value) => {
  return {
    type: SET_SHOW_REPORT_BUTTON,
    payload: value,
  };
};


export const setPracticeWorkGivenDetail = (detail) => {
  return {
    type: SET_PRACTICE_WORK_GIVEN_DETAIL,
    payload: detail,
  };
};

export const setSessionEndTime = (endTime) => {
  return {
    type: SET_SESSION_END_TIME,
    payload: endTime
  };
};
